import React, { useCallback, useEffect, useState } from 'react'
import { CRow, CCol, CCard, CCardBody, CButton, CAlert } from '@coreui/react-pro'
import CIcon from '@coreui/icons-react'
import { cilPlus, cilLayers } from '@coreui/icons'
import Table from './Table'
import AddForm from './AddForm'
import EditForm from './EditForm'
import GradeService from 'src/service/GradeService'
import StepperBar from '../SetupProgress/StepperBar'

const Grade = () => {
  const [users, setUsers] = useState([])
  const [activePage, setActivePage] = useState(1)
  const [itemsPerPage, setItemsPerPage] = useState(10)
  const [columnFilter, setColumnFilter] = useState({})
  const [columnSorter, setColumnSorter] = useState({})
  const [gameType, setGameType] = useState({})
  const [addCompVisible, setAddCompVisible] = useState(false)
  const [editGradeId, setEditGradeId] = useState(null)

  const fetchUsers = useCallback(async () => {
    const offset = itemsPerPage * activePage - itemsPerPage
    let params = new URLSearchParams()
    Object.keys(columnFilter).forEach((key) => {
      params.append(key, columnFilter[key])
    })
    columnSorter &&
      columnSorter.column !== undefined &&
      params.append('sort', `${columnSorter.column}%${columnSorter.state}`)

    try {
      const result = await GradeService.getGrades(offset, itemsPerPage, activePage, params)
      setUsers(result.data)
      setGameType(result.game_type)
    } catch (error) {
      console.error('Error fetching grades:', error)
    }
  }, [activePage, itemsPerPage, columnFilter, columnSorter])

  useEffect(() => {
    fetchUsers()
  }, [fetchUsers])

  return (
    <>
      <StepperBar activeStepKey="competitions" />
      <div className="d-flex flex-wrap justify-content-between align-items-start gap-2 mb-3">
        <div>
          <h4 className="mb-1">Competitions</h4>
          <div className="text-medium-emphasis">Manage comps (grades) and divisions.</div>
        </div>
        <div className="d-flex flex-wrap gap-2">
          <CButton color="primary" onClick={() => setAddCompVisible(true)}>
            <CIcon icon={cilPlus} className="me-1" />
            Add Comp
          </CButton>
        </div>
      </div>

      {gameType == 4 && (
        <CAlert color="danger">Restriction: You can create a maximum of 1 Comp Name only</CAlert>
      )}

      <CRow className="g-3 mb-3">
        <CCol sm={6} lg={4}>
          <CCard className="h-100">
            <CCardBody className="d-flex justify-content-between align-items-center">
              <div>
                <div className="text-medium-emphasis small">Total Comps</div>
                <div className="fs-4 fw-semibold">{users?.total ?? 0}</div>
              </div>
              <div
                className="d-flex align-items-center justify-content-center rounded-circle bg-primary-subtle text-primary"
                style={{ width: 42, height: 42 }}
              >
                <CIcon icon={cilLayers} size="lg" />
              </div>
            </CCardBody>
          </CCard>
        </CCol>
      </CRow>

      <CCard>
        <CCardBody>
          <Table
            users={users}
            fetchUsers={fetchUsers}
            setActivePage={setActivePage}
            setItemsPerPage={setItemsPerPage}
            setColumnFilter={setColumnFilter}
            setColumnSorter={setColumnSorter}
            itemsPerPage={itemsPerPage}
            activePage={activePage}
            columnFilter={columnFilter}
            columnSorter={columnSorter}
            onEditGrade={setEditGradeId}
          />
        </CCardBody>
      </CCard>

      <AddForm
        visible={addCompVisible}
        onClose={() => setAddCompVisible(false)}
        fetchUsers={fetchUsers}
      />

      <EditForm
        gradeId={editGradeId}
        visible={!!editGradeId}
        onClose={() => setEditGradeId(null)}
        fetchUsers={fetchUsers}
      />
    </>
  )
}

export default Grade
